import { render, staticRenderFns } from "./Sign-Up.vue?vue&type=template&id=cc974c8c"
import script from "./Sign-Up.vue?vue&type=script&lang=js"
export * from "./Sign-Up.vue?vue&type=script&lang=js"
import style0 from "./Sign-Up.vue?vue&type=style&index=0&id=cc974c8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports